export default "__VITE_ASSET__BVXTGjlm__"